import 'zone.js';
import { provideBrowserGlobalErrorListeners, mergeApplicationConfig } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const browserConfig = mergeApplicationConfig(appConfig, {
  providers: [provideBrowserGlobalErrorListeners()],
});

bootstrapApplication(App, browserConfig)
  .catch((err) => console.error(err));
